import React from "react";
import "./Line.css"; // Ensure you have a corresponding CSS file for styling

const Line = ({ setChartConfig, chartConfig }) => {
  const handleLineChange = (key, value) => {
    setChartConfig((prevConfig) => {
      const clone = { ...prevConfig };
      clone.stroke = {
        ...clone.stroke,
        [key]: value
      };
      return clone;
    });
  };

  return (
    <div className="line-settings-container">
      <h3>Line Settings</h3>

      {/* Line Style Dropdown */}
      <div className="line-settings-section">
        <label className="line-settings-label">Line Style</label>
        <select
          value={chartConfig?.stroke?.curve || "straight"}
          onChange={(e) => handleLineChange("curve", e.target.value)}
        >
          <option value="smooth">Smooth</option>
          <option value="straight">Straight</option>
          <option value="stepline">Step Line</option>
        </select>
      </div>

      {/* Line Width Input */}
      <div className="line-settings-section">
        <label className="line-settings-label">Line Width</label>
        <input
          type="number"
          min="1"
          value={chartConfig?.stroke?.width}
          onChange={(e) => handleLineChange("width", Number(e.target.value))}
        />
      </div>

      {/* Line Dash Array Input */}
      <div className="line-settings-section">
        <label className="line-settings-label">Line Dash Array</label>
        <input
          type="number"
          min="0"
          value={chartConfig?.stroke?.dashArray}
          onChange={(e) => handleLineChange("dashArray", Number(e.target.value))}
        />
      </div>
    </div>
  );
};

export default Line;
